<template>
  <div class="ma-8">
    <v-snackbar v-model="msg" top> {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <!-- <h1 class="text-center font-weight-light">Redhead Support Training</h1>
    <v-divider class="mb-3"></v-divider> -->
    <v-card class="mb-6">
      <v-card-subtitle class='text-center'>Select Training Type</v-card-subtitle>
      <v-layout row wrap>
        <v-flex xs12 class="pa-4 text-center">
          <v-btn
            class="mb-1 mr-1 white--text"
            @click="openPage('NHO')"
            color="#2b3990"
          >
            NHO
          </v-btn>
          <v-btn
            class="mb-1 ml-1 mr-1 white--text"
            @click="openPage('main')"
            color="#2b3990"
          >
            Monthly Training
          </v-btn>
          <v-btn
            class="mb-1 ml-1 white--text"
            @click="openPage('General')"
            color="#2b3990"
          >
            Staff Training
          </v-btn>
          <v-btn
            class="mb-1 ml-1 white--text"
            @click="openPage('DIY')"
            color="#2b3990"
          >
            DIY Training
          </v-btn>
          <v-btn
            class="mb-1 ml-1 white--text"
            @click="openPage('Policies')"
            color="#2b3990"
          >
            Policies &amp; Procedures
          </v-btn>
          <v-btn
            class="mb-1 ml-1 white--text"
            @click="openPage('Protocols')"
            color="#2b3990"
          >
            Protocols
          </v-btn>
          <v-btn
            class="mb-1 ml-1 white--text"
            @click="openPage('Common Forms')"
            color="#2b3990"
          >
            Common Forms
          </v-btn>
          <v-btn
            class="mb-1 ml-1 white--text"
            @click="openPage('All Trainings')"
            color="#2b3990"
          >
            All Training
          </v-btn>
        </v-flex>
        <v-flex xs10 mx-auto>
          <v-autocomplete
            v-if="page!=='NHO' && page !== 'All Trainings' && showDropdown"
            @change="(event) => trainingAutocomplete.event(event)"
            :items=trainingAutocomplete.items
            item-text="Training"
            :label=trainingAutocomplete.title
            return-object
            class="mt-2 w-75"
            v-model="selectedTraining"
          ></v-autocomplete>
        </v-flex>

      </v-layout>
    </v-card>

    <v-layout row wrap v-if="page!=='NHO' && page !== 'All Trainings'" class="mt-1">
      <v-flex xs12 sm12>
        <v-card class="pa-4 ma-2" v-if="title !== ''">
          <v-card-title class="blue accent-3 white--text">{{ title }}</v-card-title>
          <v-layout row wrap class="ma-5" v-if='staffDialog || dialog'>
            <v-flex xs12 class="mb-8">
              <h3 class="ml-3"> {{ trainingDescriptionLabel }} </h3>
              <v-textarea
                filled
                class="ml-2"
                v-model="description"
                :readonly=trainingDescriptionReadOnly
              ></v-textarea>
              <h3 class="ml-3">Training Outline</h3>
              <v-textarea
                filled
                class="ml-2"
                v-model="trainingOutline"
                :readonly=trainingOutlineReadOnly
              ></v-textarea>
            </v-flex>

            <v-flex xs12 sm8>
              <iframe
                v-if="!isPDF"
                class="iframe"
                width="600"
                height="415"
                :src="link"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
              <div xs12 sm8 v-if="isPDF">
                <div v-for="(item, i) in pdfDetails" :key="i" style="width: 90%; margin: 0 auto">
                  <LoadPDF :pdfFile="item.aws" :pdfName="item.name"/>
                </div>
              </div>
              <v-row>
                <v-col md="12">
                  <v-btn color="secondary" @click="openHistory">View History</v-btn>
                </v-col>
              </v-row>

            </v-flex>
            <v-flex xs12 sm4 v-show="!updateGlobalTraining">
              <v-checkbox
                v-model="filterStaffBool"
                label="Do you want to filter staff list?"
                class="ml-6"
              ></v-checkbox>

              <div v-if="filterStaffBool">
                <v-autocomplete
                  filled
                  clearable
                  label="Select Program"
                  :items="programs"
                  item-text="Name"
                  item-value="Name"
                  v-model="newProgram"
                  prepend-icon="notes"
                  @change="getDefaultStaff()"
                ></v-autocomplete>

                <v-autocomplete
                  filled
                  clearable
                  label="Select Role"
                  :items="roles"
                  v-model="newRole"
                  prepend-icon="people"
                  @change="getStaffByRole()"
                ></v-autocomplete>
              </div>

              <v-autocomplete
                filled
                clearable
                :items="users"
                item-text="Name"
                item-value="_id"
                label="Select Trainer(s)"
                multiple
                v-model="newTrainer"
                prepend-icon="person"
                v-bind:search-input.sync="searchTrainer"
                @change="selectTraininer"
              ></v-autocomplete>

              <v-autocomplete
                filled
                clearable
                :items="usersWithSelectAll"
                item-text="Name"
                item-value="_id"
                label="Staff that Attended"
                multiple
                v-model="newStaff"
                prepend-icon="person"
                hint="Type to filter staff names"
                @change="toggleSelectAll"
                v-bind:search-input.sync="searchStaffAttend"

              ></v-autocomplete>

              <v-autocomplete
                filled
                :items="trainingType"
                v-model="newTraining"
                label="Training Type"
                prepend-icon="folder"
              ></v-autocomplete>
              <v-menu>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    filled
                    :value="newDate"
                    label="Date of Training"
                    prepend-icon="date_range"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="newDate"></v-date-picker>
              </v-menu>
              <v-select
                :items="times"
                filled
                label="Start Time"
                v-model="newStart"
                prepend-icon="schedule"
                @change="calcHours()"
              ></v-select>
              <v-select
                :items="times"
                filled
                label="End Time"
                v-model="newEnd"
                prepend-icon="schedule"
                @change="calcHours()"
              ></v-select>
              <v-text-field
                filled
                label="Duration of Training (Hours)"
                v-model="newDuration"
                prepend-icon="schedule"
              ></v-text-field>
              <v-file-input
                v-model="uploadFile"
                class="pa-2"
                label="Select documents to upload"
                show-size
                filled
                multiple
                prepend-icon="mdi-camera"
                accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                @change="fileSelected"
              >
                <template #selection="{ text, index }">
                  <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                </template>
              </v-file-input>
              <v-btn @click="addGlobalTraining()" color="#2b3990" class="white--text mt-2" block>Save</v-btn>
            </v-flex>

            <v-btn v-if="updateGlobalTraining" color="#2b3990" class="white--text mt-2"
                   @click="updateInserviceTraining()" block>Update
            </v-btn>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- New Hire Orientation Section -->
    <v-layout row wrap v-if="page ==='NHO'" class="mt-1">
      <v-flex xs12 sm12>
        <v-card class="pa-4 ma-2">
          <v-card-subtitle class="text-center">New Hire Orientation</v-card-subtitle>
          <v-divider width="100%" class="mt-1"></v-divider>
          <v-card
            class="overflow-y-auto"
            height="760"
            elevation="0"
          >
            <v-btn
              v-model="day1"
              text
              class="ma-1"
              :class="{ active: nhoDay1Selected, outlined: nhoDay1Selected,  'blue--text': nhoDay1Selected, 'x-large': nhoDay1Selected}"
              @click="checkDay1()"
            >
              Day 1
            </v-btn>
            <v-btn
              v-model="day2"
              text
              class="ma-1"
              :class="{ active: !nhoDay1Selected, outlined: !nhoDay1Selected,  'blue--text': !nhoDay1Selected, 'x-large': !nhoDay1Selected}"
              @click="checkDay2()"
            >
              Day 2
            </v-btn>

            <v-autocomplete
              @change="(event) => viewOrientation(event)"
              :items="Days"
              item-text="Title"
              label="Please select"
              return-object
              class="mt-2"
              v-model="selectedTraining"
            ></v-autocomplete>
          </v-card>
        </v-card>
        <v-card class="pa-4 ma-2">
          <v-card-title class="blue accent-3 white--text">{{ orientationTitle }}</v-card-title>
        </v-card>

        <v-layout
          row
          wrap
          class="ma-5"
          v-if='orientationDialog'>

          <v-flex xs12>
            <iframe
              :src="orientationLink"
              frameborder="0"
              width="100%"
              height="600"
              allowfullscreen="true"
              mozallowfullscreen="true"
              webkitallowfullscreen="true"
            ></iframe>
          </v-flex>

        </v-layout>
      </v-flex>
      <v-flex xs1></v-flex>
    </v-layout>

    <v-layout row wrap v-if="page === 'All Trainings'" class="mt-1">
      <v-flex xs12>
        <h4 class="mt-4 ml-4">All Global Trainings</h4>
        <v-data-table
          :headers="headers"
          :items="allTrainings"
          class="table-stripped elevation-1"
        >
          <template v-slot:item.actions="{ item }" class="align-self-center">
            <v-icon small class="mr-2" @click="editGlobalTraining(item)">
              mdi-pencil
            </v-icon>
          </template>

        </v-data-table>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isOpenTrainingImagesDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <h5>Training Documents</h5>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col v-for="photo in selectedTraining.TrainingPhotos"
                     :key="photo"
                     class="d-flex child-flex"
                     cols="4">
                <v-img
                  :src="photo"
                  :lazy-src="photo"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <v-icon small class="ma-2" @click="downloadImage(photo)">
                    file_download
                  </v-icon>
                  <template v-slot:placeholder>`
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <TrainingHistory :history-dialog.sync="historyDialog" :selected-training="selectedTraining"/>
    <Foot/>
  </div>
</template>
<script>
import axios from 'axios'
import Foot from "@/components/Footer.vue"
import moment from 'moment'
import LoadPDF from '@/components/LoadPDF.vue'
import {ROLES as Roles} from '@/enums/RolesEnum'
import {TRAININGTIMES} from '@/constants/ScheduleTime'
import TrainingHistory from "@/components/Training/TrainingHistory.vue";
import {displaySuccess, displayError} from "@/service/notification-message.service";

const url = require("../client_config/config").url;


export default {
  components: {Foot, LoadPDF, TrainingHistory},
  data: () => ({
    showDropdown: false,
    trainings: [],
    staffTrainings: [],
    DIYTrainings: [],
    policies: [],
    protocols: [],
    commonForms: [],
    trainingID: "",
    nhoID: "",
    dialog: false,
    orientationDialog: false,
    link: "",
    orientationLink: "",
    orientationTitle: "",
    title: "",
    description: "",
    trainingOutline: "",
    trainingType: ["Corporate Training (All Employees)", "Manager Training (All Managers)", "Asst Manager Training",
      "House Training", "Staff Training", "Bi-Weekly Training", "Adjustment Training"],
    users: [],
    newDocument: [],
    newTraining: "",
    newStaff: [],
    newTrainer: [],
    newDate: "",
    newStart: "",
    newEnd: "",
    times: TRAININGTIMES(),
    newDuration: "",
    newInstructor: "",
    page: "main",
    NHOS: [],
    Days: [],
    day1: "Day 1",
    day2: "Day 2",
    staffDialog: false,
    isOpenTrainingImagesDialog: false,
    newTrainingPhoto: "",
    trainingPhotos: [],
    photos: [],
    selectedTraining: {},
    selectedPhoto: '',
    uploadFile: [],
    text: "",
    message: "",
    msg: "",
    readonly: false,
    isPDF: false,
    userState: localStorage.getItem('userState'),
    programs: [],
    filterStaffBool: false,
    roles: [
      Roles.ADMINISTRATION,
      Roles.DIRECT_CARE_STAFF,
      Roles.SHIFT_LEAD,
      Roles.ASSISTANT_MANAGER,
      Roles.HOUSE_MANAGER,
      Roles.PROGRAM_MANAGER,
      Roles.HUMAN_RESOURCES,
      Roles.CLIENT_SERVICES_MANAGER,
      Roles.PROGRAM_COORDINATOR,
      Roles.MEDICAL_MANAGER,
      Roles.EXECUTIVE_DIRECTOR,
      Roles.FINANCE_MANAGER,
      Roles.COMPLIANCE_MANAGER,
      Roles.PARENT_GUARDIAN,
      Roles.SUPPORT_COORDINATOR,
      Roles.CLIENT,
      Roles.PHARMACY,
    ],
    userID: localStorage.getItem("userID"),
    pdfDetails: [],
    headers: [
      {text: "Name", value: "Training", width: "20%"},
      {text: "Category", value: "Category", width: "30%"},
      {text: "Description", value: "Description", sortable: false, width: "40%"},
      {text: "Actions", value: "actions", sortable: false, width: "10%"},
    ],
    allTrainings: [],

    updateGlobalTraining: false,
    trainingAutocomplete: {
      event: null,
      title: '',
      items: []
    },
    trainingDescriptionReadOnly: false,
    trainingOutlineReadOnly: false,
    trainingDescriptionLabel: 'Training Description',
    nhoDay1Selected: null,
    searchStaffAttend: '',
    searchTrainer: '',
    historyDialog: false,
    histories: []
  }),
  computed: {
    usersWithSelectAll() {
      return [{Name: 'Select All', _id: 'select_all'}, ...this.users];
    },
  },
  isAllSelected() {
    // Check if all users are selected
    return this.newStaff.length === this.users.length;
  },
  created() {
    this.getTrainings();
    this.getNHOS();
    this.getHouseId();
    this.getUsers();
    if (localStorage.getItem('userRole')  === Roles.SUPER_ADMINISTRATOR
      || localStorage.getItem('userRole') === Roles.ADMINISTRATION
      || localStorage.getItem('userRole') === Roles.PROGRAM_MANAGER
      || localStorage.getItem('userRole') === Roles.HOUSE_MANAGER
      || localStorage.getItem('userRole') === Roles.HUMAN_RESOURCES
      || localStorage.getItem('userRole') === Roles.CLIENT_SERVICES_MANAGER
      || localStorage.getItem('userRole') === Roles.PROGRAM_COORDINATOR
      || localStorage.getItem('userRole') === Roles.MEDICAL_MANAGER
      || localStorage.getItem('userRole') === Roles.EXECUTIVE_DIRECTOR
      || localStorage.getItem('userRole') === Roles.COMPLIANCE_MANAGER
    ) {
      this.readonly = true;
      this.trainingDescriptionReadOnly = true;
      this.trainingOutlineReadOnly = false;
    }
    // this.openPage(this.page);
  },

  methods: {
    toggleSelectAll() {
      // If "Select All Staff" is selected, select or deselect all users
      if (this.newStaff.includes('select_all')) {
        if (this.isAllSelected) {
          // If all are already selected, deselect all
          this.newStaff = [];
        } else {
          // Select all users and include "Select All Staff"
          this.newStaff = this.users.map(user => user._id).concat('select_all');
        }
      } else {
        // If "Select All Staff" is deselected, clear the selection
        this.newStaff = this.newStaff.filter(id => id !== 'select_all');
        this.searchStaffAttend = ''
      }
    },
    initialize() {
      this.trainings = [];
      this.NHOS = [];
    },

    openTrainingImagesDialog() {
      this.isOpenTrainingImagesDialog = true;
    },

    viewTraining(item) {
      this.isPDF = false;
      this.selectedTraining = item;
      this.selectedTraining.TrainingPhotos = item.TrainingPhoto ? item.TrainingPhoto.split(',') : [];
      this.dialog = true;
      this.description = item.Description;
      this.trainingOutline = item.Outline;
      this.title = item.Training;
      this.link = item.Link;
      this.trainingID = item._id;
      if (item.documents !== undefined && item.documents.length > 0) {
        const tempData = [];
        for (let i = 0; i < item.documents.length; i++) {
          tempData.push({
            name: item.documents[i].Name,
            awsLink: item.documents[i].AWSLink,
          });
        }
        this.newDocument = tempData;
      }
    },

    viewStaffTraining(item) {
      this.isPDF = false;
      this.pdfDetails = []; // Clear previous PDF details
      this.selectedTraining = item;
      this.selectedTraining.TrainingPhotos = item.TrainingPhoto ? item.TrainingPhoto.split(',') : [];
      this.staffDialog = true;
      this.description = item.Description;
      this.trainingOutline = item.Outline;
      this.title = item.Training;
      this.link = item.Link;
      this.trainingID = item._id;

      // Process documents for PDFs
      if (item.documents && item.documents.length > 0) {
        const tempData = [];
        for (let i = 0; i < item.documents.length; i++) {
          const file = item.documents[i];
          const fileExt = file.AWSLink.split('.').pop().toLowerCase();
          if (fileExt === 'pdf') {
            this.isPDF = true;
            this.pdfDetails.push({
              name: file.Name,
              id: file._id,
              aws: file.AWSLink
            });
          }
          tempData.push({
            name: file.Name,
            awsLink: file.AWSLink
          });
        }
        this.newDocument = tempData;
      } else {
        this.newDocument = [];
      }
    },

    viewOrientation(nho) {
      this.orientationDialog = true;
      this.orientationTitle = nho.Title;
      this.orientationLink = nho.Link;
      this.nhoID = nho._id;
    },

    showAdd() {
      this.titleForm = "New Service Code";
      this.newServCode = true;
      this.editCode = false;
    },

    getUsers() {
      const params = {
        state: this.userState,
        companyIds: JSON.parse(localStorage.getItem('userCompanies') || '[]').join(',')
      };

      axios.get(`${url}/users/company`, { params }).then(res => {
        this.users = res.data.users;
      }).catch(error => {
        console.error("Failed to fetch users:", error);
      });

    },


    // compareTrainings(a, b) {
    //   // Check if a or b is undefined or null
    //   if (!a || !b) {
    //     return 0;
    //   }

    //   var nameA = (a.Training || '').toUpperCase();
    //   var nameB = (b.Training || '').toUpperCase();

    //   // Split the names into prefix and suffix
    //   var prefixA = nameA.replace(/[0-9]/g, '');
    //   var prefixB = nameB.replace(/[0-9]/g, '');
    //   var suffixA = parseInt(nameA.replace(/\D/g, ''));
    //   var suffixB = parseInt(nameB.replace(/\D/g, ''));

    //   // Compare the prefix
    //   if (prefixA < prefixB) return -1;
    //   if (prefixA > prefixB) return 1;

    //   // Compare the suffix if the prefixes are equal
    //   if (suffixA < suffixB) return -1;
    //   if (suffixA > suffixB) return 1;

    //   // The prefixes and suffixes are equal
    //   return 0;
    // },

    compareTrainings(a, b) {
        if (!a || !b) return 0;

        let nameA = (a.Training || '').trim().toUpperCase();
        let nameB = (b.Training || '').trim().toUpperCase();

        // Extract numeric prefix (if available)
        let numA = parseInt(nameA.match(/^\d+/)?.[0]) || null;
        let numB = parseInt(nameB.match(/^\d+/)?.[0]) || null;

        // 🟢 Prioritize items that have numbers first
        if (numA !== null && numB === null) return -1;  // A has number, B doesn't → A first
        if (numA === null && numB !== null) return 1;   // B has number, A doesn't → B first

        // 🔢 If both have numbers, sort numerically
        if (numA !== null && numB !== null) {
            if (numA !== numB) return numA - numB;
        }

        // 🔠 If both lack numbers or have the same number, sort alphabetically
        return nameA.localeCompare(nameB);
    },

    getTrainings: function () {
      this.isLoading = true;
      axios.get(`${url}/globalTraining`).then(res => {
        var temp = this.allTrainings = res.data.trainings;

        // Clear previous data
        this.staffTrainings = [];
        this.DIYTrainings = [];
        this.policies = [];
        this.protocols = [];
        this.commonForms = [];
        this.trainings = [];

        for (var i = 0; i < temp.length; i++) {
          const category = temp[i].Category || "";

          if (category === 'Staff Training') {
            this.staffTrainings.push(temp[i]);
          } else if (category === 'DIY') {
            this.DIYTrainings.push(temp[i]);
          } else if (category === 'Policies & Procedures') {
            this.policies.push(temp[i]);
          } else if (category === 'Protocols') {
            this.protocols.push(temp[i]);
          } else if (category === 'Common Forms') {
            this.commonForms.push(temp[i]);
          } else if (category === 'Monthly Training') {
            this.trainings.push(temp[i]); // Only push Monthly Training here
          } else {
            console.warn(`Uncategorized Training: ${temp[i].Training} (${category})`);
          }
        }

        // Sort all lists alphabetically
        this.staffTrainings.sort(this.compareTrainings);
        this.DIYTrainings.sort(this.compareTrainings);
        this.policies.sort(this.compareTrainings);
        this.protocols.sort(this.compareTrainings);
        this.commonForms.sort(this.compareTrainings);
        this.trainings.sort(this.compareTrainings); // Sort Monthly Trainings
        this.allTrainings.sort(this.compareTrainings);
      }).finally(() => this.isLoading = false);
    },

    getNHOS: function () {
      this.isLoading = true;
      axios.get(`${url}/nho/${this.userState}`).then(res => {
        this.NHOS = res.data.nhos;
      }).finally(() => this.isLoading = false);
    },

    async addGlobalTraining() {
      if (!Array.isArray(this.newStaff) || this.newStaff.length === 0) {
        this.msg = true;
        this.text = "No staff selected for training.";
        return;
      }

      try {
        this.isLoading = true;
        this.msg = true;
        this.text = "Please wait, we are still saving your training and uploading the document(s)...";

        if (this.uploadFile && this.uploadFile.length > 0) {
          try {
            const formData = new FormData();
            for (const file of this.uploadFile) {
              formData.append("files", file);
            }
            const fileResponse = await axios.post(`${url}/globalTraining`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
            console.log("Files uploaded successfully:", fileResponse.data);
          } catch (error) {
            console.error("File upload error:", error);
            displayError("Failed to upload files. Please try again.");
            return;
          }
        }

        const formattedDate = moment(this.newDate).startOf('day').toISOString();
        const formattedDateOnly = moment(this.newDate).format("YYYY-MM-DD");
        const start = moment(`${formattedDateOnly} ${this.newStart}`, "YYYY-MM-DD hh:mma").toISOString();
        const end = moment(`${formattedDateOnly} ${this.newEnd}`, "YYYY-MM-DD hh:mma").toISOString();

        const req_body = {
          Trainer: this.newTrainer,
          TrainingType: this.newTraining,
          TrainingSubject: this.selectedTraining.Training,
          EmployeeID: this.newStaff,
          Date: formattedDate,
          TimeStarted: start,
          TimeEnded: end,
          Duration: this.newDuration,
          Outline: this.trainingOutline,
          Description: this.description,
          Link: this.link,
          GlobalTrainingID: this.trainingID,
          Source: 'Training'
        };

        const response = await axios.post(`${url}/inserviceTraining`, req_body);

        if (response.status === 200 || response.status === 201) {
          displaySuccess("Training info has been sent to selected staff.");
          this.clearFields();
          this.$router.go(-1);
        } else if (response.status === 400 && response.data?.msg) {
          displaySuccess(response.data.msg);
        }
      } catch (error) {
        console.error("Training submission error:", error);
        displayError("An error occurred while submitting training info.");
      } finally {
        this.isLoading = false;
      }
    },

    clearFields() {
      this.newTraining = "";
      this.title = "";
      this.newStaff = "";
      this.newTrainer = [];
      this.newDate = "";
      this.newStart = "";
      this.newEnd = "";
      this.newDuration = "";
      this.description = "";
      this.trainingOutline = "";
      this.newDocument = [];
      this.isPDF = false;
      this.link = "";
      this.selectedTraining = {};
    },

    checkDay1() {
      this.Days = [];
      for (let i = 0; i < this.NHOS.length; i++) {
        if (this.NHOS[i].Day === "Day 1") {
          this.Days.push(this.NHOS[i])
        }
      }
      this.selectedTraining = {};
      this.nhoDay1Selected = true;
    },

    checkDay2() {
      this.Days = [];
      for (let i = 0; i < this.NHOS.length; i++) {
        if (this.NHOS[i].Day === "Day 2") {
          this.Days.push(this.NHOS[i])
        }
      }
      this.selectedTraining = {};
      this.nhoDay1Selected = false;
    },

    deleteChip(index) {
      this.newDocument.splice(index, 1);
    },

    selectTrainingPhotos(trainingPhotos) {
      this.trainingPhotos = trainingPhotos;
    },

    fileSelected(e) {
      this.uploadFile = e;
    },

    uploadTrainingPhotos(files) {
      const formData = new FormData();
      formData.append('trainingId', this.trainingID);

      for (let file of files) {
        formData.append('trainingPhoto[]', file);
      }

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      axios.post(`${url}/training/trainingPhoto/upload`, formData, config)
        .then(res => {
          console.log(res.data);
        })
        .catch(err => {
          console.log(err);
        });
    },

    calcHours() {
      if (this.newDate === "") {
        this.msg = true;
        this.text = "Please select date";
        return;
      }
      var start = moment(this.newDate + " " + this.newStart, "YYYY/MM/DD HH:mma")
      var end = moment(this.newDate + " " + this.newEnd, "YYYY/MM/DD HH:mma")
      var hours = end.diff(start, "minutes")
      var minutes = parseInt(hours) / 60;
      this.newDuration = minutes
    },


    getDefaultStaff() {
      axios.get(`${url}/users/house/${this.newProgram}`).then(res => {
        this.users = res.data.users
      })
    },

    getStaffByRole() {
      axios.get(`${url}/users/filterStaff/${this.newRole}/${this.newProgram}`).then((res) => {
        this.users = res.data.users
      });

    },

    getHouseId() {
      axios.get(`${url}/units/state/${this.userState}`).then((res) => {
        this.programs = res.data.units
      });
    },

    openPage(page) {
      this.page = page;
      this.description = "";
      this.trainingOutline = "";
      this.title = "";
      this.selectedTraining = {};
      this.updateGlobalTraining = false;
      this.trainingAutocomplete.event = null;
      this.trainingAutocomplete.title = null;
      this.trainingAutocomplete.items = null;
      this.trainingDescriptionLabel = 'Training Description';
      this.trainingDescriptionReadOnly = true;
      this.trainingOutlineReadOnly = false;
      this.showDropdown = true;

      let items = null;
      if (page === 'DIY') {
        items = this.DIYTrainings;
        this.trainingAutocomplete.title = 'DIY Trainings';
      } else if (page === 'Policies') {
        items = this.policies;
        this.trainingAutocomplete.title = 'Policies & Procedures';
      } else if (page === 'Protocols') {
        items = this.protocols;
        this.trainingAutocomplete.title = 'Protocols';
      } else if (page === 'Common Forms') {
        items = this.commonForms;
        this.trainingAutocomplete.title = 'Common Forms';
      } else if (page === 'General') {
        items = this.staffTrainings;
        this.trainingAutocomplete.title = 'Staff Trainings';
        this.trainingDescriptionReadOnly = false;
      } else if (page === 'main') {
        items = this.trainings;
        this.trainingAutocomplete.title = 'Monthly Trainings';
      } else {
        console.warn(`Unrecognized page: ${page}`);
        this.showDropdown = false;
      }

      if (items) {
        this.trainingAutocomplete.items = items;
        this.trainingAutocomplete.event = page === 'main' ? this.viewTraining : this.viewStaffTraining;
        const latestItem = items[items.length - 1];
        if (latestItem) {
          this.selectedTraining = latestItem;
          this.trainingAutocomplete.event(latestItem);
        }
      }
    },

    editGlobalTraining(item) {
      this.selectedTraining = item;
      const category = this.selectedTraining.Category ?? '';
      this.getInserviceTrainingDetails(item.Training);
      switch (category) {
        case 'Policies & Procedures':
          this.openPage('Policies');
          this.viewStaffTraining(item);
          break;
        case 'Staff Training':
          this.openPage('General');
          this.viewStaffTraining(item);
          break;
        case 'Monthly Training':
        case '':
          this.openPage('main');
          this.viewTraining(item);
          break;
        default:
          this.openPage(item.Category);
          this.viewStaffTraining(item);
          break;
      }
      this.updateGlobalTraining = true;
    },

    getInserviceTrainingDetails(trainingSubject) {
      axios.get(`${url}/inserviceTraining/bySubject/${trainingSubject}`).then((res) => {
        console.log(res);
      });
    },

    getInservicesByIds() {
      //
    },

    updateInserviceTraining() {
      const req_body = {
        Outline: this.trainingOutline
      };
      axios.put(`${url}/inserviceTraining/updateByGlobalTraining/${this.selectedTraining._id}`, req_body).then(res => {
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.msg = true;
        this.text = "The training info has been updated.";
        this.clearFields();
        this.openPage('All Trainings');

      });
    },
    selectTraininer() {
      console.log(this.newTrainer);
      if (this.newTrainer.length > 0) this.searchTrainer = '';
    },

    openHistory() {
      this.historyDialog = true;
    }
  }
}
</script>
<style>
@media only screen and (min-width: 768px) {

}

@media only screen and (max-width: 600px) {
  .iframe {
    width: 100%;
    height: 100%;
    padding-bottom: 40px;
  }

}

</style>
